'use strict';

var Utils = require('../../utils/utils');
var Collapse = require('./collapse');

var MobileVisibility = function(config) {

  var self = this;
  var $showContent = config.showContent;
  var $content = config.content;
  var $container = config.container;

  self.init = function() {

    var smallViewports = function() {
      new Collapse().setEventId($showContent, $content, $container);
    };

    var largeViewports = function() {
      new Collapse(null, $showContent, $content, $container).reset();
    };

    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);
  }
};

module.exports = MobileVisibility;
